import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {connect} from "src/store";
import {ComponentFormatter} from "../../../utils/formatters";
import {activeFilter} from "../../../utils/filters";

class RoyaltyList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        let {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        const licenseFilter = {
            filters: [
                {field: "licensee", value: this.props.pos.partner.partner_id},
                {field: "licensor.partner_id", value: this.props.pos.partner.partner_id}
            ],
            operator: "or"
        };
        if (filter) {
            if (Array.isArray(filter)) {
                filter.push(licenseFilter);
            } else {
                filter = {filters: [filter, licenseFilter]};
            }
        } else {
            filter = licenseFilter;
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "RoyaltyList"}
                {...props}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true}]}
                filter={filter}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        sortable,
                        filterable
                    },
                    "licensor.name": {
                        header: 'Jogtulajdonos',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "licensee.name": {
                        header: 'Felhasználó',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "agent.name": {
                        header: 'Ügynök',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "object_component.displayname": {
                        header: 'Jogcím',
                        width: 3,
                        sortable,
                        filterable
                    },
                    "active": {
                        header: 'Aktív',
                        width: 1,
                        sortable,
                        filterable: activeFilter(),
                        renderer: (value) => value + "" === "1" ? "Aktív" : "Inaktív"
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default RoyaltyList;
